import React ,{useState}from "react";
import { Card } from "react-bootstrap";
import { ImCamera } from "react-icons/im";
import { FaPhone } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
const socialLinks = [
    { href: "https://www.facebook.com/Minixithu", icon: "fab fa-facebook-f", label: "Facebook" },
    { href: "https://x.com/@MinixITHub", icon: "fab fa-twitter", label: "Twitter" },
    
    { href: "https://www.linkedin.com/company/minix-it-hub-pvt-ltd-", icon: "fab fa-linkedin-in", label: "LinkedIn" },
];
const Contact = () => {
const [captcha, setCaptcha] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captcha) {
      alert("Please verify CAPTCHA");
      return;
    }

    const response = await fetch("https://script.google.com/macros/s/AKfycbyHpGWZPzLURnS-wQF51uYw6J6pIz-ogsNrPz5Yo7rCI8tap0BKK05g3MBCXwhikFo/exec", {
      method: "POST",
      body: JSON.stringify(formData)
    });

    if (response.ok) {
      alert("Form submitted successfully!");
      setFormData({
        name: "",
        email: "",
        contact: "",
        subject: "",
        message: ""
      });
    }
  };

    return (
     <>
     <row>
<div className="col-12 row text-center">
<h1>Contact us</h1>
<h6>
Interested in our IT services or need advice? Then please get in touch and we’ll be glad to help.

</h6>

</div>
        </row>
        <row className="justify-content-center col-12 row mb-4 m-4 p-4 shadow-sm bg-light">
            <div className="col-md-7 text-center mb-4 vertical-center p-4 ">
                <img src="minix-logo.png" alt="logo" style={{ height: '100px', marginRight: '10px'}}/>   
                <br/>
                <br/>
<h2>Ready to Translate Your Business Goals into Tech Solutions?</h2>
<h6>Let's bridge the gap between vision and technology with expert guidance.</h6>
<p>
    Working Hours <br/>
Open Monday to Saturday
From 10:00 AM to 18:00 PM IST
</p>
    <h4 >Follow Us</h4>
                    <div className="col-md-12" >
                        {socialLinks.map(link => (
                            <a
                            className="p-4"
                                key={link.href}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={link.label}
                                style={{
                                    
                                    fontSize: 52,
                                    textDecoration: "none",
                                    transition: "color 0.2s"
                                }}
                            >
                                <i className={link.icon}></i>
                            </a>
                        ))}
                    </div>
    </div>
       <div className="col-md-5">
 <div className="card p-4 shadow-sm text-center">
  <form onSubmit={handleSubmit}>
      <div className="form-group text-center">
        <h2>Talk to Our Experts <FaPhone /></h2>
      </div>

      <div className="form-group m-2">
        <input type="text" className="form-control" id="name"
          placeholder="Name *" required value={formData.name}
          onChange={handleChange} />
      </div>

      <div className="form-group m-2">
        <input type="email" className="form-control" id="email"
          placeholder="Business Email *" required value={formData.email}
          onChange={handleChange} />
      </div>

      <div className="form-group m-2">
        <input type="tel" className="form-control" id="contact"
          placeholder="Contact No. *" required value={formData.contact}
          onChange={handleChange} />
      </div>

      <div className="form-group m-2">
        <input type="text" className="form-control" id="subject"
          placeholder="Subject *" required value={formData.subject}
          onChange={handleChange} />
      </div>

      <div className="form-group m-2">
        <textarea className="form-control" id="message" rows="5"
          placeholder="Message *" required value={formData.message}
          onChange={handleChange}></textarea>
      </div>

      <div className="form-group m-2">
        <ReCAPTCHA
          sitekey="6LdKlk0sAAAAABuSAJbRe8rqTGEUWP1LyLvDxumN"
          onChange={(value) => setCaptcha(value)}
        />
      </div>

      <div className="form-group m-2">
        <button type="submit" className="btn btn-lg btn-primary mt-3">
          Submit
        </button>
      </div>
    </form>
    </div>
    </div>
      
            </row>
            <row className="justify-content-center col-12 row mb-4 m-4 p-4 shadow-sm bg-light">
<h1 className="text-center">Headquarters</h1>

            </row>
            <row className="justify-content-center col-12 row mb-4 m-4 p-4 "> 
           
                    
                    <div className="col-md-6 text-center mb-4 vertical-center p-4 shadow-sm bg-light">
                        <img src="../images/jaipur.jpg" alt="logo" style={{width: '100px', height: '100px', marginRight: '10px'}}/>   
                        <br/>
                        <br/>
                        <h1>Jaipur</h1>
<h6>
    B-6, 100, Vishveshvariya Nagar, Triveni , Jaipur (Rajasthan) INDIA
</h6>
<h5>Email : info@minixithub.com</h5>
<h5>Phone : +91-7976053120</h5>
  <h4 >Location</h4>
                    <iframe
                        title="Minix IT Hub Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.1345448402285!2d75.7835568!3d26.867466099999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5177a826ee5%3A0x5aef4c866c010115!2sMiniX%20IT%20Hub%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1760345392162!5m2!1sen!2sin"
                        width="100%"
                        height="200"
                        style={{ border: 0, borderRadius: 8 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                    </div>
                         <div className="col-md-6 text-center mb-4 vertical-center p-4  shadow-sm bg-light">
      <img src="../images/gangapurcity.jpg" alt="logo" style={{width: '100px', height: '100px', marginRight: '10px'}}/>   
                        <br/>
                        <br/>
                        <h1>Gangapur city</h1>
<h6>
    46, Kanti Nagar, Near Main post Office , Gangapur city (Rajasthan) INDIA
</h6>
<h5>Email : info@minixithub.com</h5>
<h5>Phone : +91-8824703111</h5>
  <h4 >Location</h4>
                    <iframe
                        title="Minix IT Hub Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3571.3823157739116!2d76.71435079999999!3d26.475632500000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3971f6be45b231fb%3A0x27af629aa9d652b1!2sMINIX%20IT%20HUB%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1760432054524!5m2!1sen!2sin"
                        width="100%"
                        height="200"
                        style={{ border: 0, borderRadius: 8 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                    </div>
                
                  </row>
     
     </>
    );
};

export default Contact;